module.exports = __webpack_public_path__ + "f7dd44e572c13a278929364aea4ab14f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-left-29.png
// module id = 2573
// module chunks = 0